<template>
    <div class="block-editor bot-response">
        <div class="palette">
            <h4>{{ $t("chatbotv2.responses") }}</h4>
            <div class="items">
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.TEXT)">
                    <span class="icon material-icons" style="font-size: 30px">text_fields</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.TEXT.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.RANDOM_TEXT)">
                    <span class="icon material-icons" style="font-size: 30px">shuffle</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.RANDOM_TEXT.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.IMAGE)">
                    <span class="icon material-icons" style="font-size: 30px">image</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.IMAGE.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.GALLERY)">
                    <span class="icon material-icons" style="font-size: 30px">auto_awesome_motion</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.GALLERY.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.BUTTON)">
                    <span class="icon material-icons" style="font-size: 30px">view_carousel</span>
                    <span class="title"> {{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.BUTTON.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.QUICK_REPLY)">
                    <span class="icon material-icons" style="font-size: 30px">smart_button</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.QUICK_REPLY.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.FILE)">
                    <span class="icon material-icons" style="font-size: 30px">attach_file</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.FILE.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.AI_RANDOM_TEXT)">
                    <span class="icon material-icons" style="font-size: 30px">smart_button</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.AI_RANDOM_TEXT.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.AI_IMAGE)">
                    <span class="icon material-icons" style="font-size: 30px">image</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.AI_IMAGE.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.PRIVATE_MESSAGE)">
                    <span class="icon material-icons" style="font-size: 30px">disabled_visible</span>
                    <span class="title">{{ $t(`chatbotv2.${Payloads.BOT_RESPONSE.PRIVATE_MESSAGE.type}`) }}</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.DYNAMIC_BUTTON)">
                    <span class="icon material-icons" style="font-size: 30px">dynamic_feed</span>
                    <span class="title">Dynamic Button</span>
                </div>
                <div class="item" @click="addResponseItem(Payloads.BOT_RESPONSE.DYNAMIC_QUICK_REPLY)">
                    <span class="icon material-icons" style="font-size: 30px">dynamic_form</span>
                    <span class="title">Dynamic Quick Reply</span>
                </div>
            </div>
        </div>
        <div class="payload-wrapper">
            <div
                v-for="(p, i) in payload"
                class="payload"
                :key="p.id || 'payload-' + i"
                draggable="true"
                @dragstart="startDrag($event, i)"
                @drop="onDrop($event, i)"
                @dragover.prevent
                @dragenter.prevent
            >
                <div class="actions-wrapper">
                    <MessageDelaySlider v-model="payload[i].delay" @active-state="handleActiveState" />
                    <MessageDelayInput v-if="showDelayInput" v-model="payload[i].delay" />
                    <MessageFilterAdder
                        v-if="!$_.get(payload[i], 'filters.items', []).length"
                        :on-filter-added="(filterItem) => onFilterAdded(i, filterItem)"
                    />
                </div>
                <MessageFilterList
                    v-if="$_.get(payload[i], 'filters.items', []).length > 0"
                    v-model="payload[i].filters"
                    :show-remove-button="false"
                    :on-removed="(id) => onFilterRemoved(i, id)"
                    :default-selected-filter-id="lastAddedFilterId"
                />

                <div class="toolbar" v-if="!previewMode">
                    <button class="toolbar-btn" @click="payload.splice(i, 1)">
                        <md-icon style="color: #06a9f3">delete</md-icon>
                    </button>
                    <button class="toolbar-btn">
                        <md-icon style="color: #06a9f3">swap_vert</md-icon>
                    </button>
                    <button class="toolbar-btn" @click="duplicateItem(payload[i])">
                        <md-icon style="color: #06a9f3">content_copy</md-icon>
                    </button>
                </div>

                <TextMessage
                    v-model="p.text"
                    v-if="p.type === Payloads.BOT_RESPONSE.TEXT.type"
                    :preview-mode="previewMode"
                />
                <PrivateMessage
                    v-model="p.text"
                    v-if="p.type === Payloads.BOT_RESPONSE.PRIVATE_MESSAGE.type"
                    :preview-mode="previewMode"
                />
                <RandomTextMessage
                    v-else-if="p.type === Payloads.BOT_RESPONSE.RANDOM_TEXT.type"
                    :show-attributes="showAttr === i"
                    :texts="p.texts"
                    :on-updated="(data) => updateItem(p, data)"
                    :on-attribute-added="onAttributeAdded"
                />
                <AIRandomTextMessage
                    v-else-if="p.type === Payloads.BOT_RESPONSE.AI_RANDOM_TEXT.type"
                    :texts="p.texts"
                    :on-updated="(data) => updateItem(p, data)"
                    :on-attribute-added="onAttributeAdded"
                    :prompt="p.prompt"
                    :preview-mode="previewMode"
                />
                <GalleryMessageEditor
                    v-else-if="p.type === Payloads.BOT_RESPONSE.GALLERY.type"
                    :show-attributes="showAttr === i"
                    :cards="p.cards"
                    :on-updated="(data) => updateItem(p, data)"
                    :on-attribute-added="onAttributeAdded"
                    :flatted-diagram="flattedDiagram"
                />
                <ImageBotResponse
                    v-else-if="p.type === Payloads.BOT_RESPONSE.IMAGE.type"
                    :default-image-url="p.imageUrl"
                    :default-asset-id="p.assetId"
                    :default-mode="p.mode"
                    :on-updated="(data) => updateItem(p, data)"
                    :whatsapp-mode="false"
                    :allowed-attributes="allowedAttributes"
                />

                <FileBotResponse
                    v-else-if="p.type === Payloads.BOT_RESPONSE.FILE.type"
                    :default-file-url="p.fileUrl"
                    :default-asset-id="p.assetId"
                    :on-updated="(data) => updateItem(p, data)"
                />

                <ButtonMessageEditor
                    v-else-if="p.type === Payloads.BOT_RESPONSE.BUTTON.type"
                    v-model="payload[i]"
                    :flattedDiagram="flattedDiagram"
                />
                <QuickReplyMessageEditor
                    :flattedDiagram="flattedDiagram"
                    v-else-if="p.type === Payloads.BOT_RESPONSE.QUICK_REPLY.type"
                    v-model="payload[i]"
                />
                <AIImage
                    v-else-if="p.type === Payloads.BOT_RESPONSE.AI_IMAGE.type"
                    v-model="p.prompt"
                    :preview-mode="previewMode"
                />
                <DynamicButtonMessageEditor
                    v-else-if="p.type === Payloads.BOT_RESPONSE.DYNAMIC_BUTTON.type"
                    v-model="payload[i]"
                    :flattedDiagram="flattedDiagram"
                />
                <DynamicQuickReplyMessageEditor
                    v-else-if="p.type === Payloads.BOT_RESPONSE.DYNAMIC_QUICK_REPLY.type"
                    v-model="payload[i]"
                    :flattedDiagram="flattedDiagram"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { Payloads } from "../../../chatbot";
import _ from "lodash";
import log2 from "../../../../../../utils/log2";
import ImageBotResponse from "./bot-response/ImageBotResponse";
import FileBotResponse from "./bot-response/FileBotResponse";
import RandomTextMessage from "./bot-response/RandomTextMessage";
import GalleryMessageEditor from "./bot-response/GalleryMessageEditor";

import TiptapEditor from "../common/TiptapEditor";
import ButtonMessageEditor from "./bot-response/ButtonMessageEditor";
import QuickReplyMessageEditor from "./bot-response/QuickReplyMessageEditor";
import MessageDelaySlider from "../common/MessageDelaySlider";
import MessageDelayInput from "../common/MessageDelayInput";
import TextMessage from "./bot-response/TextMessage";
import MessageFilterAdder from "../common/MessageFilterAdder";
import MessageFilterList from "./bot-response/MessageFilterList";
import AIRandomTextMessage from "./bot-response/AIRandomTextMessage";
import AIImage from "./bot-response/AIImage";
import DynamicButtonMessageEditor from "./bot-response/DynamicButtonMessageEditor";
import DynamicQuickReplyMessageEditor from "./bot-response/DynamicQuickReplyMessageEditor";
import PrivateMessage from "./bot-response/PrivateMessage.vue";
import Vue from "vue";
import { generateRandomId } from "../../../../../../utils/session";

const log = log2("BotResponse");
export default {
    name: "BotResponse",
    props: ["value", "flattedDiagram", "previewMode", "allowedAttributes"],
    components: {
        MessageDelaySlider,
        TextMessage,
        ImageBotResponse,
        FileBotResponse,
        RandomTextMessage,
        GalleryMessageEditor,
        ButtonMessageEditor,
        QuickReplyMessageEditor,
        TiptapEditor,
        MessageFilterAdder,
        MessageFilterList,
        MessageDelayInput,
        AIRandomTextMessage,
        AIImage,
        DynamicButtonMessageEditor,
        DynamicQuickReplyMessageEditor,
        PrivateMessage,
    },
    data() {
        return {
            showDelayInput: false,
            payload: (this.value || []).filter((x) => !!x),
            newPayload: [],
            Payloads,
            showAttr: null,
            lastAddedFilterId: null,
        };
    },
    methods: {
        handleActiveState(state) {
            this.showDelayInput = state;
        },
        duplicateItem(item) {
            const newItem = _.cloneDeep(item);
            newItem.id = generateRandomId();
            this.payload.push(newItem);
        },
        addResponseItem(item) {
            log("addResponseItem", item);
            if (this.previewMode) {
                this.$message.error("Cannot add this item in preview mode");
                return;
            }
            const newItem = _.cloneDeep(item);
            newItem.id = generateRandomId();
            this.payload.push(newItem);
        },
        updateItem(item, payload) {
            log("updateItem", { item, payload });
            if (this.previewMode) {
                this.$message.error("Cannot add this item in preview mode");
                return;
            }
            Object.keys(payload).forEach((key) => {
                item[key] = payload[key];
            });
        },
        addAttribute(x, i) {
            if (this.previewMode) {
                this.$message.error("Cannot add this item in preview mode");
                return;
            }
            log("addAttribute");
            this.showAttr = null;
            const attrEl = `<span class="attribute-chip" data-attribute="${x}" contenteditable="false">${x}</span>`;
            this.payload[i].text += attrEl;
        },
        onAttributeAdded() {
            this.showAttr = null;
        },
        onFilterAdded(index, filterItem) {
            log("onFilterAdded", { index, filterItem });
            const filtersObject = this.payload[index].filters || {
                operator: "or",
                items: [],
            };
            filtersObject.items.push(filterItem);
            Vue.set(this.payload[index], "filters", _.cloneDeep(filtersObject));

            this.lastAddedFilterId = filterItem.id;
            this.$nextTick();
        },
        onFilterRemoved(index, filterId) {
            const filtersObject = this.payload[index].filters || {
                operator: "or",
                items: [],
            };
            filtersObject.items = filtersObject.items.filter((item) => item.id !== filterId);
            this.payload[index].filters = filtersObject;
        },
        startDrag(evt, draggedPointIndex) {
            log(
                "payload before DAD",
                this.payload.map((x) => x.type)
            );
            log("DAD dragg point", this.payload[draggedPointIndex].type);
            evt.dataTransfer.dropEffect = "move";
            evt.dataTransfer.effectAllowed = "move";
            evt.dataTransfer.setData("itemIndex", draggedPointIndex);
        },
        onDrop(evt, droppedPointIndex) {
            this.newPayload = [];
            log("DAD drop point ", this.payload[droppedPointIndex].type);
            const draggedPointIndex = evt.dataTransfer.getData("itemIndex");
            const moveIndex = (arr, from, to) => {
                const item = arr[from];
                arr.splice(from, 1);
                arr.splice(to, 0, item);
                return arr;
            };
            this.newPayload = this.payload;
            this.newPayload = this.payload;
            this.payload = moveIndex(this.newPayload, draggedPointIndex, droppedPointIndex);
            log(
                "payload after DAD",
                this.payload.map((x) => x.type)
            );
        },
    },
    mounted() {
        log("mounted", { previewMode: this.previewMode });
    },
    watch: {
        payload: {
            deep: true,
            handler(newValue, oldValue) {
                log("payload changed", newValue, oldValue);
                this.$emit("input", this.payload);
            },
        },
    },
};
</script>

<style scoped lang="scss">
.palette {
    max-height: 80vh;
    overflow-y: auto;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px #00000040;
    position: fixed;
    //right: 37rem;
    //top: 4.4rem;

    right: 43rem;
    top: 1.1rem;
    min-width: 250px;
    padding: 1rem;

    .items {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 1rem;
    }

    .item {
        text-align: center;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &:hover {
            color: #006cff;

            .img,
            .icon {
                border: 1px solid #006cff;
            }
        }

        .icon {
            width: 80px;
            height: 80px;
            border: 1px solid #dedede;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .title {
            margin-top: 5px;
        }

        .img {
            border: 1px solid #dedede;
            border-radius: 4px;
            min-height: 60px;
            margin-bottom: 6px;
        }
    }
}

.bot-response {
    .payload-wrapper {
        &:hover {
            //border: 1px dashed black;
        }
    }
}

.payload-wrapper {
    min-height: 200px;

    .payload:hover .attr-btn {
        opacity: 1;
        transform: translateY(0);
    }

    .attr-btn {
        border: none;
        background: #fff;
        position: absolute;
        bottom: -6px;
        right: 70px;
        border-radius: 50%;
        box-shadow: 0 0 6px #76767621;
        width: 32px;
        height: 32px;
        opacity: 0;
        transform: translateY(100%);
        transition: all 0.3s ease-in-out;
    }

    .actions-wrapper {
        display: flex;
        gap: 10px;
        margin-bottom: 6px;
    }
}
</style>
